// カラーミーショップの認可(OAuth)を「このブラウザで始めたもの」だけ受け付けるための控え。
//
// 認可を始めるときに state と用途(ログインか連携か)を sessionStorage に残し、
// 戻ってきたときに URL の state と突き合わせる。一致しなければ処理しない。
// 他人が用意した「戻りの URL」を踏まされても、その人のアカウントでログインさせられない
// ようにするため(ログイン CSRF 対策)。用途もここに持たせるので、前回の旗が残って
// 次のログインが連携として扱われることもない。
const KEY = "colorme_oauth_pending";

export type ColormeOAuthMode = "login" | "link";

type Pending = { state: string; mode: ColormeOAuthMode };

// 認可 URL から state を取り出して控え、その URL へ移る
export const beginColormeOAuth = (authorizeUrl: string, mode: ColormeOAuthMode): void => {
  try {
    const state = new URL(authorizeUrl).searchParams.get("state");
    if (state) sessionStorage.setItem(KEY, JSON.stringify({ state, mode } as Pending));
  } catch {
    // 控えを残せないと戻ってきたときに処理できないが、画面が案内を出すので黙って進める
  }
  window.location.href = authorizeUrl;
};

// 戻ってきたときに 1 回だけ読む。state が一致したときだけ用途を返す
export const takeColormeOAuth = (state: string | null): ColormeOAuthMode | null => {
  try {
    const raw = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    if (!raw) return null;
    const pending = JSON.parse(raw) as Pending;
    if (state === null) return pending.mode; // 認可をやめて戻ってきた(用途だけ知りたい)
    return pending.state === state ? pending.mode : null;
  } catch {
    return null;
  }
};
